import defer from './defer';

const ownProp = Object.prototype.hasOwnProperty;

let grecaptcha = null;
export function createRecaptcha(isGrecaptchaEnt) {
  const deferred = defer();
  return {
    notify() {
      grecaptcha = isGrecaptchaEnt ? window.grecaptcha.enterprise : window.grecaptcha;
      deferred.resolve();
    },

    wait() {
      return deferred.promise;
    },

    render(ele, options, cb) {
      this.wait().then(() => {
        let id = grecaptcha.render(ele, options);
        cb(id);
      });
    },

    reset(widgetId) {
      if (typeof widgetId === 'undefined') {
        return;
      }

      this.assertLoaded();
      this.wait().then(() => grecaptcha.reset(widgetId));
    },

    execute(widgetId) {
      if (typeof widgetId === 'undefined') {
        return;
      }
      this.assertLoaded();
      this.wait().then(() => {
        grecaptcha.execute(widgetId);
      });
    },

    checkRecaptchaLoad() {
      if (
        ownProp.call(window, 'grecaptcha') &&
        ownProp.call(grecaptcha, 'render')
      ) {
        this.notify();
      }
    },

    assertLoaded() {
      if (!deferred.resolved()) {
        throw new Error('ReCAPTCHA has not been loaded');
      }
    }
  };
}

export default createRecaptcha;
